import { render } from "./footers.vue?vue&type=template&id=0677f2b7"
const script = {}

import exportComponent from "/Users/yunusemresogut/Desktop/ishesap-partner/bayi_v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__